import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-689d0173"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "goods-table-mobile",
  "data-cy": "rma-mobile-table"
}
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "title"
}
const _hoisted_4 = { class: "tickets-wrapper" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ticket-info" }
const _hoisted_9 = { class: "ticket-number" }
const _hoisted_10 = { class: "ticket-type" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "ticket-img-wrapper" }
const _hoisted_13 = {
  key: 0,
  class: "images"
}
const _hoisted_14 = {
  key: 1,
  class: "images"
}
const _hoisted_15 = { class: "img-wrapper" }
const _hoisted_16 = { class: "img-wrapper" }
const _hoisted_17 = { class: "number" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "goods"
  })
], -1))
const _hoisted_19 = {
  key: 1,
  class: "empty"
}
const _hoisted_20 = {
  key: 1,
  class: "ticket-row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "altText"
}
const _hoisted_23 = {
  key: 1,
  class: "altText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.change)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.t("ORDER.TABLE_TITLE_CHANGE")), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.t("ORDER.TABLE_TITLE")), 1)),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.rmas && _ctx.rmas.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rmas, (ticket) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ticket.rmaCase.id,
                class: "ticket-row"
              }, [
                _hoisted_6,
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.redirectTo('TicketDetail', { tid: ticket.rmaCase.id })),
                  class: "a-row"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(ticket.rmaCase.code), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t(`COMMON.RETURN_TYPES.${ticket.rmaCase.type}.DESCRIPTION`)), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["ticket-status", ticket.rmaCase.state.toLowerCase()])
                    }, _toDisplayString(_ctx.t(`COMMON.RMA_STATES.${ticket.rmaCase.state}`)), 3)
                  ]),
                  (ticket.items !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (ticket.items.length < 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.items, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item,
                                    class: "img-wrapper"
                                  }, [
                                    _createElementVNode("div", {
                                      class: "goods",
                                      style: _normalizeStyle(
                        'background-image: url(' +
                          item.imageUrl +
                          '), url(' +
                          require(`@/assets/images/image-not-found-${_ctx.lang}.jpg`) +
                          ')'
                      )
                                    }, null, 4)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", {
                                    class: "goods",
                                    style: _normalizeStyle(
                        'background-image: url(' +
                          ticket.items[0].imageUrl +
                          '), url(' +
                          require(`@/assets/images/image-not-found-${_ctx.lang}.jpg`) +
                          ')'
                      )
                                  }, null, 4)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", {
                                    class: "goods",
                                    style: _normalizeStyle(
                        'background-image: url(' +
                          ticket.items[1].imageUrl +
                          '), url(' +
                          require(`@/assets/images/image-not-found-${_ctx.lang}.jpg`) +
                          ')'
                      )
                                  }, null, 4)
                                ]),
                                _createElementVNode("div", _hoisted_17, "+" + _toDisplayString(ticket.items.length - 2), 1)
                              ])),
                          _hoisted_18
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.t("COMMON.NO_GOODS")), 1))
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            (_ctx.change)
              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.t("ORDER.EMPTY_LISTING_CHANGE")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.t("ORDER.EMPTY_LISTING")), 1))
          ]))
    ])
  ]))
}